// extracted by mini-css-extract-plugin
export default {"socialsBar":"SocialsBar_socialsBar__DYcVa","socialsBarIcons":"SocialsBar_socialsBarIcons__o2zFE"};